import { render, staticRenderFns } from "./DoctorOut.vue?vue&type=template&id=215a5ba3&"
import script from "./DoctorOut.vue?vue&type=script&lang=js&"
export * from "./DoctorOut.vue?vue&type=script&lang=js&"
import style0 from "./DoctorOut.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports